'use strict';

angular.module('far.club')
    .controller('EventsClubController', function ($log,
                                                  $http,
                                                  $window,
                                                  $timeout,
                                                  $q,
                                                  pagination) {
        var vm = {
            constructor: constructor,
            pagination: pagination('events', {next: nextPage, itemsOnPage: 4}),
            type: 4,
            filter: {
                period: 'all',
                eventData: null
            },
            clubId: null,
            personalEvents: [],
            events: []
        };

        function constructor(clubId) {
            vm.clubId = clubId;
            vm.pagination.clear();
        }

        function nextPage(page, count) {
            var eventData = {};

            if (vm.filter.eventData) {
                eventData[vm.filter.eventData] = true;
            }

            return $http.get(Routing.generate('api_event_get_eventplans', {
                club_id: vm.clubId,
                type: vm.type,
                offset: (page - 1) * count,
                limit: count,
                period: vm.filter.period,
                event_data: eventData
            })).then(function (response) {
                var items = [];
                vm.totalPages = Math.ceil(response.headers('X-Total-Count') / count);

                angular.forEach(response.data, function (item) {
                    items.push(item);
                });

                return items;
            }).catch(function (response) {
                $log.error(response);
                return $q.reject(response);
            });
        }

        return vm;
    });